export default __webpack_public_path__ + "static/media/title.fd132f75.svg";